import React, { Component, Fragment } from 'react'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'
import { withApollo } from 'react-apollo'

const style = theme => ({
  card: {
    overflow: 'visible'
  },
  root: {
    padding: theme.spacing.unit * 2,
    flexGrow: 1
  },
  input: {
    display: 'flex',
    padding: 0
  },
  italicizedText: {
    fontStyle: 'italic'
  },
  fileDownloadIcon: {
    marginLeft: theme.spacing.unit,
    marginRight: -theme.spacing.unit
  },
  wrapFileName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '250px'
  },
  cardHeaderAction: {
    marginTop: '0px',
    marginRight: '-8px'
  },
  selectSytle: {
    width: '80%'
  },
  dividerStyle: {
    margin: '10px 0px 0 0'
  },
  subHeading: {
    margin: '5px 0'
  }
})

class SubscriptionDetails extends Component {
  render() {
    const { classes, subscriptionData } = this.props
    const {
      billingDetails,
      deviceModel,
      accessoryType,
      serviceProvider
    } = subscriptionData
    return (
      <Card className={classes.card}>
        <CardHeader title="Subscription Details" />
        {billingDetails ? (
          <CardContent>
            <Grid container spacing={16}>
              {/* Software Row */}
              {billingDetails.softwareBill ? (
                <Grid item xs={12}>
                  <Grid container alignItems="baseline" spacing={8}>
                    <Grid item xs={12}>
                      <Typography gutterBottom variant="h3" component="h3">
                        Software
                      </Typography>
                    </Grid>
                    <Grid container justify="flex-start" alignItems="flex-end">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="h3" component="h4">
                          AquilaTrack Software
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="softwareQuantity"
                          label="Software Quantity *"
                          value={this.props.softwareQuantity}
                          inputProps={{
                            min: billingDetails.softwareBill.quantity
                          }}
                          onChange={this.props.handleChange('softwareQuantity')}
                          type="number"
                          margin="none"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography gutterBottom variant="h3" component="body2">
                          Software Charges
                        </Typography>
                        <Typography variant="h3" component="h4">
                          {billingDetails.softwareBill.rate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          Total Amount per month (excl GST): &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          {isNaN(parseInt(this.props.softwareTotalAmount, 10))
                            ? '-'
                            : this.props.softwareTotalAmount}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Device Row */}
              {billingDetails.hardwareBill ? (
                <Grid item xs={12}>
                  <Grid container alignItems="baseline" spacing={8}>
                    <Grid item xs={12}>
                      <Typography gutterBottom variant="h3" component="h3">
                        Devices
                      </Typography>
                    </Grid>
                    <Grid container justify="flex-start" alignItems="flex-end">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="h3" component="h4">
                          {deviceModel.model_name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="quantity"
                          label="Device Quantity *"
                          value={this.props.deviceQuantity}
                          onChange={this.props.handleChange('deviceQuantity')}
                          type="number"
                          inputProps={{
                            min: billingDetails.hardwareBill.quantity
                          }}
                          margin="none"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography gutterBottom variant="h3" component="body2">
                          Device Charges
                        </Typography>
                        <Typography variant="h3" component="h4">
                          {billingDetails.hardwareBill.rate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          Total Amount per month (excl GST): &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          {isNaN(parseInt(this.props.deviceTotalAmount, 10))
                            ? '-'
                            : this.props.deviceTotalAmount}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Accessories Row */}
              {billingDetails.accessoryBill ? (
                <Grid item xs={12}>
                  <Grid container alignItems="baseline" spacing={8}>
                    <Grid item xs={12}>
                      <Typography gutterBottom variant="h3" component="h3">
                        Accessory
                      </Typography>
                    </Grid>
                    <Grid container justify="flex-start" alignItems="flex-end">
                      <Grid item xs={12} sm={3}>
                        <Typography gutterBottom variant="h3" component="body2">
                          Accessory Name
                        </Typography>
                        <Typography variant="h3" component="h4">
                          {accessoryType && accessoryType.accessoryName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="accessoryQuantity"
                          label="Quantity"
                          disabled={this.props.accessoryQuantity === 0 && true}
                          value={this.props.accessoryQuantity}
                          onChange={this.props.handleChange(
                            'accessoryQuantity'
                          )}
                          type="number"
                          inputProps={{
                            min: billingDetails.accessoryBill.quantity
                          }}
                          margin="none"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography gutterBottom variant="h3" component="body2">
                          Accessory Charges
                        </Typography>
                        <Typography variant="h3" component="h4">
                          {billingDetails.accessoryBill.rate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          Total Amount per month (excl GST): &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          {isNaN(parseInt(this.props.accessoryTotalAmount, 10))
                            ? '-'
                            : this.props.accessoryTotalAmount}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}

              {/* Divider Line */}
              <Grid item xs={12}>
                <Divider className={classes.dividerStyle} />
              </Grid>

              {/* Sims Row */}
              {billingDetails.simBill ? (
                <Grid item xs={12}>
                  <Grid container alignItems="baseline" spacing={8}>
                    <Grid item xs={12}>
                      <Typography gutterBottom variant="h3" component="h3">
                        Service Provider
                      </Typography>
                    </Grid>
                    <Grid container justify="flex-start" alignItems="flex-end">
                      <Grid item xs={12} sm={3}>
                        <Typography variant="h3" component="h4">
                          {serviceProvider && serviceProvider.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          id="simQuantity"
                          label="Quantity"
                          disabled={this.props.simQuantity === 0 && true}
                          value={this.props.simQuantity}
                          onChange={this.props.handleChange('simQuantity')}
                          type="number"
                          inputProps={{ min: billingDetails.simBill.quantity }}
                          margin="none"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography gutterBottom variant="h3" component="body2">
                          Sim Charges
                        </Typography>
                        <Typography variant="h3" component="h4">
                          {billingDetails.simBill.rate}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body1">
                          Total Amount per month (excl GST): &nbsp;
                        </Typography>
                        <Typography variant="body2">
                          {isNaN(parseInt(this.props.simTotalAmount, 10))
                            ? '-'
                            : this.props.simTotalAmount}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </CardContent>
        ) : (
          <CardContent>
            <Typography
              gutterBottom
              color="error"
              variant="sub-heading"
              component="body2"
            >
              Sorry! No Subscriptions are available.
            </Typography>
          </CardContent>
        )}

        {billingDetails ? (
          <CardActions>
            <Button
              color="secondary"
              variant="raised"
              onClick={this.props.handleUpdateClick}
            >
              Update
            </Button>
            <Button color="secondary" onClick={this.props.handleCancelClick}>
              Cancel
            </Button>
          </CardActions>
        ) : null}
      </Card>
    )
  }
}

SubscriptionDetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(style)(withApollo(SubscriptionDetails))



// WEBPACK FOOTER //
// ./src/components/Pages/EditSubscription/subscriptionDetails.jsx